export default "__VITE_ASSET__6b642066__"